// Module Federation runtime plugin. Loaded on both browser and Node compiles.
//
// Resolves the fe_common remote's manifest URL at RUNTIME — from process.env on
// the server, from window.__RUNTIME_CONFIG__ in the browser (written by
// src/pages/_document.tsx) — so one build serves every environment. The value
// nextjs-mf fixes in at build time (see resolveRemote in next.config.mjs) is only
// a placeholder that this plugin replaces on every start. It also patches the
// remote snapshot so chunk URLs resolve against the mount the manifest was
// fetched from, for both manifest shapes fe-common publishes (FAAS-754).
//
// All of that logic lives in @fe-toolkit; this file only maps the remote name to
// its env vars. It loads inside the federation bootstrap, so it must stay
// React-free, like mfOfflineHandlingPlugin.js alongside it.

// we are aware that the import here comes from the modern js folder and was intended
// to be used with that framework. However it uses Module Federation's own hooks (init,
// loadRemoteSnapshot), plus process.env on the server and window.__RUNTIME_CONFIG__ in the browser.
// Those work the same in Next.
import { createRuntimeRemotesPlugin } from '@fe-toolkit/utility/modern/client'

export default createRuntimeRemotesPlugin({
  remotes: {
    fe_common: {
      publicEnvVar: 'FE_COMMON_REMOTE',
      serverEnvVar: 'SERVER_FE_COMMON_REMOTE',
    },
  },
})
